module.exports = __webpack_public_path__ + "img/score_9.f600928d.png";